<template>
	<v-container>
    <v-layout row>
      <v-flex xs5 sm4 md4><h3>Appointments/Encounters for date:</h3></v-flex>
      <v-flex xs3 sm3 md3>
        <v-menu
          ref="dateMenu"
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              label="Date"
              hint="DD/MM/YYYY"
              persistent-hint
              prepend-icon="event"
              @blur="encounterDate = parseDate(dateFormatted)"
              v-on="on"
            ></v-text-field>
          </template>
        </v-menu>
      </v-flex>
    </v-layout>
    <!-- <div v-for="(encounter, index) of encounters" :key="index">
      <v-layout row>
        <v-flex xs3 sm4 md4>
          <v-text-field
              v-model="encounter.patientId"
              label="Patient Id"
            ></v-text-field></v-flex>
        <v-flex xs3 sm4 md4>
          <v-text-field
              v-model="encounter.patientName"
              label="Patient Name"
              disabled
            ></v-text-field>
        </v-flex>
        <v-flex xs3 sm4 md4><v-text-field
              v-model="encounter.patientName"
              label="Patient Name"
              disabled
            ></v-text-field></v-flex>
        <v-flex xs3 sm4 md4><v-text-field
              v-model="encounter.status"
              label="Status"
              disabled
            ></v-text-field></v-flex>
        <v-flex xs3 sm4 md4><v-text-field
              v-model="encounter.serviceType"
              label="Service Type"
              disabled
            ></v-text-field></v-flex>
            <v-flex xs3 sm4 md4><v-text-field
              v-model="encounter.performer"
              label="Performer"
              disabled
            ></v-text-field></v-flex>
      </v-layout> -->
      <div>
		  <v-data-table
        :headers="headers"
        :items="encounters">
        <template v-slot:item.patientId="props">
          <v-edit-dialog
            :return-value.sync="props.item.patientId"
            @save="save"
            @cancel="cancel"
            @open="open"
            @coles="close">
            {{ props.item.patientId }}
            <template v-slot:input>
              <v-autocomplete
                v-model="props.item.patientId"
                :items="patientURs"
                :search-input.sync="search"
                color="white"
                hide-no-data
                hide-selected
                item-text="Description"
                item-value="API"
                label="SVHA URs"
                placeholder="Start typing to Search"
                prepend-icon="mdi-database-search"
                return-object
              ></v-autocomplete>

              <!-- <v-autocomplete
                v-model="props.item.patientId"
                :items="patientURs"
                outlined
                dense
                label="UR"
              ></v-autocomplete> -->
              <!-- <v-text-field
                v-model="props.item.patientId"
                label="UR"
                single-line
              ></v-text-field> -->
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.serviceType="props">
          <v-edit-dialog
          :return-value.sync="props.item.serviceType"
          large
          persistent
          @save="save"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          <!-- <template v-slot:input>
            <div class="mt-4 title">Update Iron</div>
          </template> -->
          <template v-slot:input>
            <!-- <v-text-field
              v-model="props.item.serviceType"
              :rules="[max25chars]"
              label="Edit"
              single-line
              counter
              autofocus
            ></v-text-field> -->
            <v-select :items="serviceTypes" v-model="props.item.serviceType" label="Click to select"></v-select>
          </template>
        </v-edit-dialog>
        </template>
        <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-cellphone
      </v-icon>
    </template>
      </v-data-table>
    </div>
    <v-btn @click="addEncounter">Add encounter</v-btn>
    <v-snackbar v-model="snackBar.active" :timeout="3000" color="info">
      {{ snackBar.text }}
      <v-btn text @click="snackBar.active = false">Close</v-btn>
    </v-snackbar>
	</v-container>
</template>

<script>
import dayjs from 'dayjs'

export default {
  data () {
    return {
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateMenu: false,
      encounterDate: new Date().toISOString().substr(0, 10),
      encounters: [],
      headers: [
        { text: 'Patient UR', value: 'patientId' },
        { text: 'Patient Name', value: 'patientName' },
        { text: 'Encounter status', value: 'status' },
        { text: 'Encounter type', value: 'serviceType' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      patientURs: [],
      search: null,
      serviceTypes: ['initial', 'review'],
      snackBar: { active: false, text: '' }
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.encounterDate)
    }
  },
  methods: {
    addEncounter () {
      this.encounters.push({
        patientId: 'click to edit',
        patientName: '',
        period: { start: new Date() },
        serviceType: '',
        status: 'pending'
      })
    },
    cancel () {
      console.log('field canceled')
    },
    close () {
      console.log('field closed')
    },
    async getEncounters () {
      const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/encounters/bulk`)
      let encounters = results.data.map(encounter => ({
        patientId: encounter.patient[0].identifier[0].value,
        patientName: `${encounter.patient[0].name[0].family}, ${encounter.patient[0].name[0].given}`,
        performer: '',
        period: encounter.period,
        serviceType: encounter.serviceType,
        status: 'pending'
      }))
      return encounters
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    open () {
      console.log('field opened')
    },
    parseDate (date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    save () {
      this.snackBar.text = 'saved'
      this.snackBar.active = true
    }
  },
  async created () {
    // this.encounters = await this.getEncounters()
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patients`)
    this.patientURs = results.data.map(pat => pat.identifier[0].value)
  }
}
</script>
